import  { useEffect, useState } from "react";
import { useTypeIncomeService } from "../../../Services/TypeIncome";
import "../../../Css/Paginas.css"
import {
  Stack,
  Typography,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  MenuItem,

} from "@mui/material";
import { Add } from "@mui/icons-material";
import { FaTrashCan } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa";
import { TbFaceIdError } from "react-icons/tb";

import {
  buttonGuardar,
  Input,
  buttonCancelar,
  BoxBoton,
  buttonAtras,
  SubTitulo
} from "../../../Layouts/CustomStyles";

import { DataGrid } from "@mui/x-data-grid";

export const TipodeIngresos = () => {
  const { PostTypeIncomes, GetTypeIncomes, DeleteTypeIncomes, UpdateTypeIncomes } =
    useTypeIncomeService();

  const [typeIncomes, setTypeIncomes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Dialog States
  const [openDialog, setOpenDialog] = useState(false);
  const [actionType, setActionType] = useState("");
  const [currentItem, setCurrentItem] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [actionResult, setActionResult] = useState(null);
  const [inputName, setInputName] = useState("");
const [tipoResultado, setTipoResultado] = useState("");


  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await GetTypeIncomes();
      setTypeIncomes(data);
    } catch (error) {
      console.error("Error al obtener tipos de ingresos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const openEditDialog = (item) => {
  setActionType("edit");
  setCurrentItem(item);
  setInputName(item.name);
  setTipoResultado(item.tipo_resultado);
  setActionResult(null);
  setOpenDialog(true);
};


  const openCreateDialog = () => {
  setActionType("create");
  setInputName("");
  setTipoResultado("");
  setActionResult(null);
  setOpenDialog(true);
};


  const openDeleteDialog = (item) => {
    setActionType("delete");
    setCurrentItem(item);
    setActionResult(null);
    setOpenDialog(true);
  };

  const handleAction = async () => {
  setActionLoading(true);
  try {
    const payload = {
      name: inputName,
      tipo_resultado: tipoResultado,
    };

    if (actionType === "create") {
      await PostTypeIncomes(payload);
    } else if (actionType === "edit") {
      await UpdateTypeIncomes(currentItem.id, payload);
    } else if (actionType === "delete") {
      await DeleteTypeIncomes(currentItem.id);
    }

    setActionResult("success");
    await fetchData();
  } catch (error) {
    setActionResult("error");
  } finally {
    setActionLoading(false);
  }
};


  const handleCloseDialog = () => {
    setOpenDialog(false);
    setActionResult(null);
    setCurrentItem(null);

  };

  if (loading) {
    return (
      <Stack alignItems="center" mt={4}>
        <CircularProgress />
      </Stack>
    );
  }

  // 🔹 Columnas del DataGrid
  const columns = [
    {
      field: "name",
      headerName: "Tipo de ingreso",
      flex: 1,
      renderCell: (params) => (
        <Typography sx={{ fontFamily: "Poppins" }}>{params.row.name}</Typography>
      ),
    },
    {
      field: "tipo_resultado",
      headerName: "categoria EERR",
      flex: 1,
      renderCell: (params) => (
        <Typography sx={{ fontFamily: "Poppins" }}>{params.row.tipo_resultado}</Typography>
      ),
    },
    {
      field: "acciones",
      headerName: "Acciones",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <button onClick={() => openEditDialog(params.row)} className="edit-button">
            <svg className="edit-svgIcon" viewBox="0 0 512 512" width={20} height={20}>
              <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231z"></path>
            </svg>
          </button>
           <button onClick={() => openDeleteDialog(params.row)} className="delete-button">
            <FaTrashCan size={18} className="delete-svgIcon" />
          </button>
        </Box>
      ),
    },
  ];

  return (
    <>
      {/* BOTÓN CREAR */}
      <Box sx={BoxBoton}>
        <Button sx={buttonGuardar} startIcon={<Add />} onClick={openCreateDialog}>
          Crear nuevo ingreso
        </Button>
      </Box>

      {/* DATAGRID */}
      <Box sx={{ height: 450, width: "100%", mt: 3 }}>
        <DataGrid
          rows={typeIncomes}
          columns={columns}
          getRowId={(row) => row.id}
          pageSize={7}
          rowsPerPageOptions={[7]}
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            fontFamily: "Poppins",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#5a918d7b",
            },
          }}
        />
      </Box>

      {/* DIALOG */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle sx={SubTitulo}>
          {actionType === "create"
            ? "Crear nuevo tipo de ingreso"
            : actionType === "edit"
            ? "Editar tipo de ingreso"
            : "Eliminar tipo de ingreso"}
        </DialogTitle>

        <DialogContent sx={{ alignItems: "center", justifyContent: "center" }}>
          {actionLoading ? (
            <CircularProgress />
          ) : actionResult ? (
            actionResult === "success" ? (
              <Stack alignItems="center" spacing={2}>
                <FaCheck size={48} color="green" />
                <Typography sx={SubTitulo}>
                  {actionType === "create"
                    ? "Tipo de ingreso creado correctamente"
                    : actionType === "edit"
                    ? "Tipo de ingreso actualizado correctamente"
                    : "Tipo de ingreso eliminado correctamente"}
                </Typography>
              </Stack>
            ) : (
              <Stack alignItems="center" spacing={2}>
                <TbFaceIdError size={48} color="red" />
                <Typography sx={SubTitulo}>
                  Ocurrió un error. Inténtalo nuevamente.
                </Typography>
              </Stack>
            )
          ) : actionType === "delete" ? (
            <Typography sx={{ fontFamily: "Poppins", textAlign: "center" }}>
              ¿Seguro que deseas eliminar <strong>{currentItem?.name}</strong>?
            </Typography>
          ) : (
            <>
           <TextField
  label="Nombre"
  value={inputName}
  onChange={(e) => setInputName(e.target.value)}
  fullWidth
  sx={Input}
/>

<TextField
  label="Categoría EERR"
  select
  value={tipoResultado}
  onChange={(e) => setTipoResultado(e.target.value)}
  fullWidth
  sx={{...Input, mt:2}}
>
  <MenuItem value="OPERACIONAL">Operacional</MenuItem>
  <MenuItem value="NO_OPERACIONAL">No operacional</MenuItem>
   <MenuItem value="FINANCIAMIENTO">Financiamiento</MenuItem>
   <MenuItem value="GENERAL">General</MenuItem>
</TextField>

            </>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          {!actionResult && (
            <Button onClick={handleCloseDialog} sx={buttonAtras}>
              Cancelar
            </Button>
          )}

          {!actionResult && (
            <Button onClick={handleAction} sx={buttonCancelar}>
              {actionType === "create"
                ? "Crear"
                : actionType === "edit"
                ? "Editar"
                : "Eliminar"}
            </Button>
          )}

          {actionResult && (
            <Button onClick={handleCloseDialog} sx={buttonGuardar}>
              Cerrar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};
